import React from 'react';
import { node } from 'prop-types';
import { brandShape } from 'shapes';
import { Provider } from './BrandContext';

const BrandProvider = ({ brand, children }) => {
    return (
        <Provider
            value={{
                state: {
                    brand,
                },
            }}
        >
            {children}
        </Provider>
    );
};

BrandProvider.propTypes = {
    brand: brandShape.isRequired,
    children: node.isRequired,
};

export default BrandProvider;
